import { useState } from "react";
import { Form } from "../components";
import { Tools } from "../utils";

const useForm = ({
  extras = [],
  initialValues = {},
}: { extras?: any[]; initialValues?: {} } = {}) => {
  const [form] = Form.useForm();
  const [focusedField, setFocusedField] = useState("");
  const [formId] = useState(() => `form-${Tools.uuid()}`);

  return {
    ...form,
    extras,
    initialValues,
    uuid: formId,
    onFieldFocus: setFocusedField,
    isFieldFocused: (name = "") => name === focusedField,
    handleSubmit:
      (onSubmit: (values: Record<string, any>) => void) => async (e?: any) => {
        if (e) e.preventDefault();
        await form.validateFields();
        onSubmit(form.getFieldsValue());
      },
    setBlur: (name: string) => {
      document.getElementById(`${name}`)?.blur();
    },
  };
};

export default useForm;
